module.exports = __webpack_public_path__ + "images/tencent_docs/slide-grid-2b28d6b1dcb1c2a8a68cc022f701d0bb.png";